import {Button} from "react-bootstrap";

export const SCHEDULER_MOBILE_BACKLOG_VIEW = "backlog";
export const SCHEDULER_MOBILE_WORKER_VIEW = "worker";

export default function SchedulerMobileTabs({
    activeView,
    backlogCount,
    onChange,
    workerCount,
}) {
    return (
        <div className="scheduler-mobile-tabs" role="tablist" aria-label="Scheduler lists">
            <Button
                className="scheduler-mobile-tab"
                variant={activeView === SCHEDULER_MOBILE_BACKLOG_VIEW ? "primary" : "outline-primary"}
                role="tab"
                aria-selected={activeView === SCHEDULER_MOBILE_BACKLOG_VIEW}
                onClick={() => onChange(SCHEDULER_MOBILE_BACKLOG_VIEW)}
            >
                Backlog <span className="scheduler-mobile-tab-count">({backlogCount})</span>
            </Button>
            <Button
                className="scheduler-mobile-tab"
                variant={activeView === SCHEDULER_MOBILE_WORKER_VIEW ? "primary" : "outline-primary"}
                role="tab"
                aria-selected={activeView === SCHEDULER_MOBILE_WORKER_VIEW}
                onClick={() => onChange(SCHEDULER_MOBILE_WORKER_VIEW)}
            >
                Worker <span className="scheduler-mobile-tab-count">({workerCount})</span>
            </Button>
        </div>
    );
}
